import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { FlexCol } from '../misc';

// @overflow
// @width
export const Container = styled('div')`
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 50;

  @media screen and (min-width: 40rem) {
    height: 95vh;
    width: 95vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media screen and (min-width: 52rem) {
    height: 75vh;
    width: 90vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

// @width
// @overflow
// @flex
export const InnerContainer = styled('div')`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;

  > button {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 40;
  }

  @media screen and (min-width: 52rem) {
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
  }
`;

// @width
// @flex
export const ImageContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 33.33333333333%;
  width: 100%;
  background-color: white;
  padding: 0 ${themeGet('space.4')}px;
  border-bottom: 2px solid ${themeGet('colors.greyLight')};

  @media screen and (min-width: 40rem) {
    flex: 0 0 50%;
  }

  @media screen and (min-width: 52rem) {
    flex: 0 0 65%;
    border-right: 2px solid ${themeGet('colors.greyLight')};
    border-bottom: none;
  }
`;

// @width
// @flex
// @transform
export const ArticleDetailContent = styled(FlexCol)`
  flex: 1 1 auto;
  width: 100%;
  padding: ${themeGet('space.4')}px;
  background: ${themeGet('colors.greyLightest')};

  @media screen and (min-width: 52rem) {
    justify-content: center;
  }
`;

export const ArticleDetailTable = styled('table')`
  width: 100%;
  padding: ${themeGet('space.4')}px 0;
  border-bottom: 0.7px solid rgba(218, 225, 231, 1);
  border-top: 0.7px solid rgba(218, 225, 231, 1);

  td {
    padding-bottom: ${themeGet('space.2')}px;
    vertical-align: top;
  }

  td:first-child {
    color: ${themeGet('colors.blueDarker')};
    text-transform: uppercase;
    letter-spacing: 0.1px;
    font-weight: 300;
  }

  td:last-child {
    color: ${themeGet('colors.black')};
    text-align: left;
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/articledetail/style.js